export enum RFQApi {
  GetProductsByText = '/api/rfq/upload-free-text',
  GetProductsByUrl = '/api/rfq/upload-url-html',
  GetJobIdByFile = '/api/rfq/upload',
  GetJobIdByUrl = '/api/rfq/upload-url',
  GetProductsById = '/api/rfq/result',
  GetJobStatus = '/api/rfq/status',
  GetProductDetails = '/api/competitor-product/summary',
  GetProductsByImageUrl = '/api/rfq/upload-image-url',
  GetProductsByManufacturer = '/api/rfq/upload-mfg-sku-name',
  GetFilesQueue = '/api/rfq/upload-url/file-queue',
  GetFilesStatuses = '/api/rfq/metadata',
  GetExportedFile = '/api/rfq/export'
}

export enum AutoRFQApi {
  Create = '/rfq',
  GetAll = '/rfq/',
  GetAllShared = '/rfq/shared',
  GetSingle = '/rfq/:id',
  Update = '/rfq/:id',
  GetMatchedItems = '/rfq/matched',
  GetItems = '/rfq/items/:id',
  SaveItems = '/rfq/items/:id',
  UpdateItem = '/rfq/items/:rfqItemId',
  DeleteSingle = '/rfq/:id',
  GenerateCSV = '/rfq/csv/:id',
  GetListAnalytics = '/rfq/list-analytics',
  GetListAnalyticsShared = '/rfq/list-analytics/shared',
  GetRFQResults = '/api/rfq/result/file-queue',
  GetRfqItem = '/rfq/item/:id',
  GetRfqAnalytics = '/rfq/analytics/:id',
  Configurations = '/rfq/configuration',
  GetItemsMetadata = '/rfq/items/:rfqId/metadata',
  CustomerNote = '/rfq/items/:rfqItemId/customer-note',
  InternalNotes = '/rfq/items/:rfqItemId/internal-notes',
  InternalNote = '/rfq/items/:rfqItemId/internal-notes/:noteId',
  InternalShare = '/rfq/:rfqId/internal-share',
  InternalShareUser = '/rfq/:rfqId/internal-share/:userId'
}
